import { Link, useParams } from 'react-router-dom';
import { tenantBasePath } from '../../lib/tenant.js';
import { JournalDocumentCard } from './JournalDocumentCard.js';

/**
 * UI_REFERENCE_SOURCE:
 * section: Sakhtar Cloud ERP v2.dc.html `/t/kimia/finance` journals tab, card
 *   «سند» (number + status badge + actions, meta strip, lines grid with the
 *   «جمع سند · n» totals row and «سند تراز است» indicator) + Sakhtar
 *   Finance.dc.html §03 JOURNAL DETAIL + REVERSAL (immutable notice on a
 *   posted document, reversal confirm with optional date + backdating reason).
 * archetype: TRANSACTION_DETAIL — deep-link route; the same card is the right
 *   pane of the journals master/detail (JournalsPage.tsx), see
 *   JournalDocumentCard.tsx for the shared implementation.
 * status: KIT_CONFORMANT — the board's «سابقهٔ گردش سند» status history needs a
 *   per-transition audit log the journal-detail endpoint doesn't return (only
 *   the current status); «ثبت‌کننده»/«تأییدکننده»/«دورهٔ مالی» are not on
 *   `JournalEntryResponse` (apps/api/src/accounting/dto.ts); no print endpoint.
 *   None are fabricated. The reversal dialog's date/reason map to the real
 *   `reverse` endpoint's optional `businessDate`/`backdatingReason`.
 * state reference: ready · permission_denied · not_found · network_error
 */
export function JournalDetailPage() {
  const { slug, journalId } = useParams<{ slug: string; journalId: string }>();
  if (!slug || !journalId) return null;
  const base = tenantBasePath(slug);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div className="sk-breadcrumb">
        <span>مالی</span>
        <span>/</span>
        <Link to={`${base}/finance/journals`}>اسناد حسابداری</Link>
        <span>/</span>
        <b>سند</b>
      </div>
      <JournalDocumentCard base={base} journalId={journalId} />
    </div>
  );
}
